import React from 'react';
const IconStatusPlayingFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 20.37L19.5 12L5 3.63V20.37Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconStatusPlayingFill;